export enum VotingView {
  LIST = 1,
  NEW = 2,
  DETAIL = 3,
  DETAIL_MEMBERS = 4,
  DETAIL_INVITATIONS = 5,
  DETAIL_ATTACHMENTS = 6,
  DETAIL_QUESTIONS = 7,
  DETAIL_RESULTS = 8,
  DETAIL_SETTINGS = 9,
  ARCHIVE = 10,
}
